import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import * as actions from "../store/actions/index";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import PrimaryAppBarNoMenu from "./PrimaryAppBarNoMenu";
import Footer from "../containers/Footer/Footer";
import withSizes from "react-sizes";
import ArbitrationRules from "./ArbitrationRules";
import Button from '@material-ui/core/Button';
import leftIcon from '../../src/images/left.png'
import Grid from '@material-ui/core/Grid';

const styles = (theme) => ({
  container: {
    /*==display: 'flex',
      flexWrap: 'wrap',*/
    fontSize: "16px",
  },
  margin: {
    margin: theme.spacing.unit,
    fontSize: "16px",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: "100%",
    fontSize: "16px",
    //flexBasis: 200,
  },
  dense: {
    marginTop: 19,
    fontSize: "16px",
  },
  card: {
    //position: 'relative',
    // minWidth: 200,
    width: "auto",
    fontSize: "16px",
    // marginRight: 6,
    //maxWidth: '25%',
    marginTop: "20px",
    //float:'right',
  },
  cardContent: {
    margin: "auto",
    padding: "0",
    fontSize: "16px",
  },
  menu: {
    width: "100%",
    fontSize: "16px",
  },
  form: {
    padding: "0 1em 1em 1em",
    fontSize: "18px",
  },
  input: {
    marginTop: "1em",
    fontSize: "18px",
  },
  bInput: {
    background: "rgba(255, 255, 255, 0.5)",
    outline: "0",
    color: "#99192D",
    wordWrap: "break-word",
    wordBreak: "break-word",
    border: "2px solid #99192D",
    paddingTop: "15px",
    paddingBottom: "15px",
    borderRadius: "25px",
    // height: "30px",
    marginLeft: "3px",
    marginRight: "3px",
    textTransform: 'none',
    boxSizing: "border-box",
    fontSize: "16px",
    "&:hover": {
      color: "white",
    },
  },
  link: {
    textDecoration: "none",
    fontSize: "16px",
    // pointerEvents: 'none',
  },
  cardAction: {
    justifyContent: "right",
    fontSize: "16px",
  },
  notify: {
    justifyContent: "center",
    alignText: "center",
    fontSize: "16px",
  },
  resize: {
    fontSize: 14,
  },
  labelRoot: {
    fontSize: 14,
  },
});

class ArbitrationRulesMain extends Component {
  state = {
    username: "",
    password: "",
    showPassword: false,
    loginInProgress: false,
    windowHeight: undefined,
    windowWidth: undefined,
  };

  performLogin = (event) => {};

  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  submitHandler = (event) => {
    event.preventDefault();
    //this.props.onSetRedirectPath('/home');
    //this.setState({loginInProgress: true,})
    this.props.onAuth(this.state.username, this.state.password);
    //this.props.history.push(this.props.authRedirect);
  };

  componentWillReceiveProps(props) {
    this.setState({ loginInProgress: props.loginInProgress });
  }

  handleResize = () => {
    this.setState({
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    });
    this.innerWidth = window.innerWidth;
    console.log(
      "Window Size: window.innerHeight: " +
        window.innerHeight +
        " window.innerWidth: " +
        window.innerWidth +
        " div 4: " +
        window.innerWidth / 4
    );
  };

  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  handleClick() {
    this.props.history.push(`/`)
  }
  render() {
    const { classes, isAuthenticated, error, newAccount } = this.props;

      return (
        <div>
            {/* <PrimaryAppBarNoMenu/> */}
            <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  style={{width:'auto', display:'block'}}
              >
                      <Grid item >
                          <Button onClick={(e)=>{this.handleClick()}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                      </Grid>
                      <Grid item >
                        <ArbitrationRules/>
                      </Grid>
              </Grid>
          
           
            <Footer />
        </div>
      );
    
  }
}

ArbitrationRulesMain.contextTypes = {
  t: PropTypes.func,
};

const mapStateToProps = (state) => {
  console.log(state);
  return {
    loginInProgress: state.auth.loginInProgress,
    isAuthenticated: state.auth.token !== null,
    error: state.auth.error,
    authRedirect: state.auth.authRedirect,
    newAccount: state.auth.newAccount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAuth: (username, password) => dispatch(actions.auth(username, password)),
    onSetRedirectPath: (path) => dispatch(actions.setAuthRedirect(path)),
  };
};

const mapSizesToProps = (sizes) => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet: withSizes.isTablet(sizes),
  isDesktop: withSizes.isDesktop(sizes),
  isGtMobile: withSizes.isGtMobile(sizes),
  isGtTablet: withSizes.isGtTablet(sizes),
  isStTablet: withSizes.isStTablet(sizes),
  isStDesktop: withSizes.isStDesktop(sizes),
  isTabletAndGreater: withSizes.isTabletAndGreater(sizes),
  isTabletAndSmaller: withSizes.isTabletAndSmaller(sizes),
});

// export default withRouter( connect(mapStateToProps, mapDispatchToProps) (withStyles(styles) (withSizes(mapSizesToProps)) (LoginForm)) ) ;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSizes(mapSizesToProps)(withStyles(styles)(withRouter(ArbitrationRulesMain))));
